import classNames from 'classnames';
import { View } from 'components';
import * as icons from 'icons';
import styles from './Icon.module.scss';

const Icon = ({
  name,
  s,
  className,
  onClick,
  disabled,
  highlight,
  black,
  x,
  margin,
  ...rest
}) => {
  const Component = icons[name];

  if (!Component) return null;

  return (
    <View
      className={classNames(
        styles.Icon,
        onClick && styles.Icon__clickable,
        disabled && styles.Icon__disabled,
        s && styles.Icon__s,
        highlight && styles.Icon__highlight,
        margin && styles.Icon__margin,
        x && styles.Icon__x,
        highlight &&
          highlight !== true &&
          styles[`Icon__highlight__${highlight}`],
        styles[`Icon__name__${name}`],
        `Icon__name__${name}`,
        Icon.displayName,
        className
      )}
      onClick={onClick ? onClick : undefined}
      role={onClick ? 'button' : undefined}
      {...rest}
    >
      <Component />
    </View>
  );
};

Icon.displayName = 'Icon';

export default Icon;
